import { render, staticRenderFns } from "./TMobileEmptyCheckbox.vue?vue&type=template&id=61ff424b&scoped=true&"
import script from "./TMobileEmptyCheckbox.vue?vue&type=script&lang=js&"
export * from "./TMobileEmptyCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TMobileEmptyCheckbox.vue?vue&type=style&index=0&id=61ff424b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ff424b",
  null
  
)

export default component.exports